import AddCircleIcon from '@mui/icons-material/AddCircle';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import React, { useEffect, useState } from 'react';
import useMyMApi from '../../hooks/useMyMApi';
import useWebContext from '../../hooks/useWebContext';
import { MyMLabel } from '../../ui-elements/MyMLabel';
import { MyMProgress } from '../../ui-elements/MyMProgress';
import { Pager } from '../../ui-parts/Pager';
import NotificationManagementListTable from './NotificationManagementListTable';

/** MyMine Version2.0 Notification機能追加
 * NotificationManagement List Component
 */
const NotificationManagementList = ({ screenId, initNotificationManagedPage, needsRefreshPage, setNeedsRefresh, setModalInfo }) => {
  
  const apiRequest = useMyMApi(screenId);
  const { controlSettings, messageList, screenSettings } = useWebContext(screenId);
  const [pagingNotificationManagedPage, setPagingNotificationManagedPage] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [isPaging, setIsPaging] = useState(false);
  const [isInitLoaded, setIsInitLoaded] = useState(false);

  // 初期表示
  useEffect(() => {
    setIsInitLoaded(true);
  }, []);

  // ページング
  useEffect(() => {
    // 初期表示時はなにも行わない
    if (isInitLoaded === false) { return; }
    requestPage(pageNumber);
  }, [pageNumber]);

  // ページングリロード
  useEffect(() => {
    if (needsRefreshPage === true) {
      if (pageNumber === 1) {
        requestPage(1);
      } else {
        setPageNumber(1);
      }
      setNeedsRefresh(false);
    }
  }, [needsRefreshPage]);

  /**
   * ページングリクエスト
   * @param {number} requestPageNumber ページ番号
   */
  const requestPage = (requestPageNumber) => {
    setIsPaging(true);

    const callbackRequestPage = (result) => {
      // ページ番号が2以上で検索結果が無い場合、前のページで再検索
      if (requestPageNumber > 1 && result.ItemList.length === 0) {
        setPageNumber(requestPageNumber - 1);
        return;
      }
      setPagingNotificationManagedPage(result);
      setIsPaging(false);
    }

    apiRequest.requestJson(`api/notification/managed-page?LimitMaxRowCount=${screenSettings.MaxRowCount}&PageNumber=${requestPageNumber}`, 'GET', callbackRequestPage);
  }

  /** Notificationアイコン定義 */
  const iconControlList = {
    published: {
      control: (size) => <CheckCircleIcon color='success' sx={{ fontSize: size === 'large' ? '35px' : '20px' }} />,
      text: controlSettings.LabelList.lblPublishedIconTitle
    },
    expired: {
      control: (size) => <AddCircleIcon sx={{
        color: 'red',
        transform: 'rotate(45deg)',
        fontSize: size === 'large' ? '36px' : '21px',
      }} />,
      text: controlSettings.LabelList.lblExpiredIconTitle
    }
  };

  const showNotificationPage = pagingNotificationManagedPage ?? initNotificationManagedPage;

  return (
    <>
      {isPaging && <MyMProgress />}
      <Box>
        <MyMLabel className='ps-2' fontWeight='bold'>{controlSettings.LabelList.lblNotificationList}</MyMLabel>
      </Box>
      <NotificationManagementListTable
        notificationManagedPage={showNotificationPage}
        iconControlList={iconControlList}
        setModalInfo={setModalInfo}
        controlSettings={controlSettings}
        messageList={messageList}
        screenSettings={screenSettings} />
      {/* 一覧結果がある場合、アイコン凡例表示 */}
      {showNotificationPage.ItemList.length > 0 &&
        <Stack direction='row' spacing={3} className='my-2'>
          {Object.keys(iconControlList).map((key) =>
            <Box key={key} className='d-flex'>
              {iconControlList[key].control('small')}
              <MyMLabel className='ps-1'>{iconControlList[key].text}</MyMLabel>
            </Box>
          )}
        </Stack>
      }
      {/* ページング */}
      <Pager
        resultListItem={showNotificationPage}
        handleChangePage={(pageNum) => setPageNumber(pageNum)}
        labelList={controlSettings.LabelList}
        pageNumber={pageNumber}>
      </Pager>
    </>
  );
}
export default NotificationManagementList;
